module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "affiliateInstitution",
    staticClass: "affiliate-institution-modal",
    class: {
      'show-md-dark-mode': _vm.showMode
    },
    attrs: {
      "md-open-from": "#affiliateInstitution",
      "md-close-to": "#affiliateInstitution"
    },
    on: {
      "open": _vm.fixContent,
      "close": _vm.startOver
    }
  }, [_c('md-dialog-title', [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Institutional Affiliation")]), _vm._v(" "), _c('div', {
    staticClass: "close_modal",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('md-dialog-content', {
    staticClass: "affiliate-institution-modal-content"
  }, [_c('div', {
    staticClass: "select-your-institution"
  }, [(_vm.currentUid) ? _c('div', {
    staticClass: "ai-current"
  }, [_c('div', {
    staticClass: "ai-caption"
  }, [_vm._v("Currently affiliated with")]), _vm._v(" "), _c('div', {
    staticClass: "ai-current-row"
  }, [_c('span', {
    staticClass: "ai-current-name",
    class: {
      'ai-pending-remove': _vm.institution === ''
    }
  }, [_vm._v(_vm._s(_vm.currentName || 'Your institution'))]), _vm._v(" "), (_vm.institution !== '') ? _c('button', {
    staticClass: "ai-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.institution = ''
      }
    }
  }, [_vm._v("Remove")]) : _c('button', {
    staticClass: "ai-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.institution = _vm.currentUid
      }
    }
  }, [_vm._v("Undo")])]), _vm._v(" "), (_vm.institution === '') ? _c('div', {
    staticClass: "ai-hint"
  }, [_vm._v("Will be removed when you confirm.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "ai-caption",
    attrs: {
      "for": "ai-search"
    }
  }, [_vm._v(_vm._s(_vm.currentUid ? 'Change institution' : 'Find your institution'))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "ai-search",
    attrs: {
      "id": "ai-search",
      "type": "search",
      "placeholder": "Search by name",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.onQuery]
    }
  }), _vm._v(" "), (_vm.queryTooShort) ? _c('div', {
    staticClass: "ai-status"
  }, [_vm._v("Type at least 3 letters")]) : (_vm.searching) ? _c('div', {
    staticClass: "ai-status"
  }, [_vm._v("Searching…")]) : (_vm.results.length) ? _c('ul', {
    staticClass: "ai-results",
    attrs: {
      "role": "listbox"
    }
  }, _vm._l((_vm.results), function(r) {
    return _c('li', {
      key: r.uid,
      class: {
        selected: _vm.institution === r.uid
      },
      attrs: {
        "role": "option",
        "aria-selected": _vm.institution === r.uid
      },
      on: {
        "click": function($event) {
          _vm.institution = r.uid
        }
      }
    }, [_c('span', {
      staticClass: "ai-radio"
    }), _vm._v(" "), _c('span', {
      staticClass: "ai-name"
    }, [_vm._v(_vm._s(r.institution_name))]), _vm._v(" "), (_vm.institution === r.uid) ? _c('span', {
      staticClass: "ai-check"
    }, [_vm._v("✓")]) : _vm._e()])
  }), 0) : (_vm.searchedFor) ? _c('div', {
    staticClass: "ai-status"
  }, [_vm._v("No institutions match “" + _vm._s(_vm.searchedFor) + "”.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "select-your-institution-fields ai-actions"
  }, [_c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.changeInstitution
    }
  }, [_vm._v("Confirm Changes")])], 1), _vm._v(" "), _c('p', [_vm._v("This is how your institution will find you. Once you have chosen your institution, your Cuelist administrator will be able to activate your account.")]), _vm._v(" "), _c('p', [_vm._v("If you don't see your institution listed here, please reach out to your local administrator or "), _c('a', {
    attrs: {
      "href": "mailto:info@thecuelist.com"
    }
  }, [_vm._v("contact")]), _vm._v(" Cuelist with any questions or concerns.")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7511a47b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/affiliate-institution.vue
// module id = 1262
// module chunks = 21